"use client";

import { cn } from "@/lib/utils";
import {
  getLTrustInfo,
  formatLTrustScore,
  type LTrustInfo,
} from "@/lib/l-trust";

interface LTrustBadgeProps {
  score: number;
  size?: "sm" | "md" | "lg";
  showLabel?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: "text-xs px-1.5 py-0.5 gap-0.5",
  md: "text-sm px-2 py-1 gap-1",
  lg: "text-base px-3 py-1.5 gap-1.5",
};

export function LTrustBadge({
  score,
  size = "md",
  showLabel = false,
  className,
}: LTrustBadgeProps) {
  const info: LTrustInfo = getLTrustInfo(score);

  return (
    <span
      className={cn(
        "inline-flex items-center font-medium rounded-full",
        info.bgColor,
        info.color,
        sizeClasses[size],
        className
      )}
    >
      <span className="font-semibold">{formatLTrustScore(info.score)}</span>
      {showLabel && <span className="opacity-80">{info.label}</span>}
    </span>
  );
}
